'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require('redux');

var _reducer = require('./reducer');

var _reducer2 = _interopRequireDefault(_reducer);

var _api = require('./api');

var _api2 = _interopRequireDefault(_api);

var _reduxThunk = require('redux-thunk');

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reduxLogger = require('redux-logger');

var _reduxLogger2 = _interopRequireDefault(_reduxLogger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = function (initialState, endpoint, id) {
  var api = (0, _api2.default)(endpoint, id, {
    loadMore: function loadMore(_ref, query) {
      var data = _ref.data,
          rest = _objectWithoutProperties(_ref, ['data']);

      return {
        results: query.params.page === 1 ? data : [].concat(_toConsumableArray(query.results), _toConsumableArray(data)),
        pagination: rest
      };
    }
  });

  var getMiddleware = function getMiddleware() {
    var res = [_reduxThunk2.default, api];

    if (process.env.NODE_ENV === 'production') {
      return res;
    }

    return [].concat(res, [_reduxLogger2.default]);
  };

  return (0, _redux.createStore)(_reducer2.default, initialState, _redux.applyMiddleware.apply(undefined, _toConsumableArray(getMiddleware())));
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/@jump/pages/lib/createStore.js
// module id = 257
// module chunks = 0